import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';
import { CustomerAuthenticationBillingTableRowActions } from '../reports/interfaces';
import { CustomerAuthenticationBillingResponseItem, CustomerAuthenticationBillingTableData } from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: CustomerAuthenticationBillingResponseItem[],
  actions: CustomerAuthenticationBillingTableRowActions
): CustomerAuthenticationBillingTableData[] =>
  data.map((CustomerAuthenticationBillingItem: CustomerAuthenticationBillingResponseItem) => {
    const { cost, id, ...rest } = CustomerAuthenticationBillingItem;

    const actionsProp = [
      {
        name: TABLE_ACTION.INFO,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actions.openDetails(id);
        }
      }
    ];

    return {
      ...rest,
      id,
      cost: cost.value,
      actions: <ActionsColumn actions={actionsProp} />
    };
  });
